import { SectionMessage, Props as SectionMessageProps } from "./SectionMessage";
import styles from "./SectionMessage.module.css";
import cn from "classnames";

interface Props extends SectionMessageProps {
  // A SectionMessage can be contained in a partial empty page or in smaller containers.
  // Because of that, it will need different sizes.
  // For example, if it is contained in a dashboard widget, it will need to be smaller.
  size?: "S" | "M";
}

export function ContainedMessage(props: Props) {
  const { size = "M" } = props;

  return (
    <div className={cn(styles.containedMessage, styles[`size-${size}`])}>
      <SectionMessage {...props} />
    </div>
  );
}
